export default "__VITE_ASSET__yQTwGAGw__"